/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';
require('flickity-as-nav-for');
require('flickity-fade');
require('flickity-sync');
require('flickity-imagesloaded');

export function productImagesSlider() {
  var productImagesSlider = document.querySelector('.productInfo__mediaSlider');
  var flkty = new Flickity(productImagesSlider, {
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    fade: true,
    sync: '.productInfo__mediaSliderNav',
    draggable: false,
    imagesLoaded: true
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.productInfo__mediaSlider');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }

  // Slider Nav
  var productImagesSliderNav = document.querySelector('.productInfo__mediaSliderNav');
  var flkty = new Flickity(productImagesSliderNav, {
    // options
    contain: true,
    imagesLoaded: true,
    asNavFor: '.productInfo__mediaSlider',
    prevNextButtons: true,
    pageDots: false,
    cellAlign: 'left',
    imagesLoaded: true,
    on: {
      ready: function () {
        setTimeout(() => {
          flkty.resize();
        }, 1000);
      }
    }
  });

  var timeout = false, // holder for timeout id
      delay   = 250; // delay after event is "complete" to run callback

  window.addEventListener('resize', function () {
    // clear the timeout
    clearTimeout(timeout);
    // start timing for event "completion"
    timeout = setTimeout(function () {
      flkty.resize();
    }, delay);
  });

  // const swiper = new Swiper('.productInfo__mediaSlider', {
  //   // Optional parameters
  //   direction: 'horizontal',

  //   // And if we need scrollbar

  //   slidesPerView: 1,
  //   effect: "fade"
  // });

  // var swiper = new Swiper(".productInfo__mediaSliderNav", {
  //   loop: true,
  //   spaceBetween: 15,
  //   slidesPerView: 5,
  //   freeMode: true,
  //   watchSlidesProgress: true,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //   },
  // });
  // var swiper2 = new Swiper(".productInfo__mediaSlider", {
  //   loop: true,
  //   spaceBetween: 0,
  //   thumbs: {
  //     swiper: swiper,
  //   },
  //   effect: 'fade'
  // });


}
